import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-my-positions',
  templateUrl: './my-positions.component.html',
  styleUrls: ['./my-positions.component.css']
})
export class MyPositionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
